var _G, _Defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
function SvgDelete(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "gray",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#delete_svg__clip0)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M12 24.002a.526.526 0 01-.252-.064l-10.476-5.74A.523.523 0 011 17.742V6.263a.52.52 0 01.272-.457L11.748.066a.522.522 0 01.504 0l10.477 5.74a.524.524 0 01.271.457v11.478a.521.521 0 01-.271.458l-10.477 5.739a.526.526 0 01-.252.064zm-9.952-6.57L12 22.885l9.952-5.453V6.572L12 1.12 2.048 6.57v10.861zm14.666-.213a.524.524 0 01-.37-.152L12 12.74l-4.344 4.327a.525.525 0 01-.89-.37.52.52 0 01.15-.368l4.343-4.327-4.344-4.327a.522.522 0 11.741-.737L12 11.264l4.344-4.326a.525.525 0 01.898.367.522.522 0 01-.157.37l-4.344 4.327 4.344 4.327a.521.521 0 01-.37.89z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "delete_svg__clip0"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    transform: "translate(0 .002)",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgDelete;